import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaChartLine,
  FaTh,
  FaTag,
  FaTags,
  FaTable,
  FaUpload,
  FaCalendarAlt,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import tobreLogo from "../assets/pic/tobreLogo.svg";

const SidePanel = ({ isOpen, onClose }) => {
  const { pathname } = useLocation();
  const [isExpanded, setIsExpanded] = useState(true);

  const menuItems = [
    { path: "/dashboard/home", label: "Dashboard", icon: FaChartLine },
    { path: "/dashboard/queue", label: "Print Queue", icon: FaTable },
    { path: "/dashboard/uploadcard", label: "Upload Cards", icon: FaUpload },
    { path: "/dashboard/cards", label: "Card Bank", icon: FaTh },
    { path: "/dashboard/events", label: "Events Offered", icon: FaCalendarAlt },
     // ✅ New Coupon Pages
    { path: "/dashboard/coupons/create", label: "Create Coupon", icon: FaTag },
    { path: "/dashboard/coupons/list", label: "Coupons List", icon: FaTags },
     
    
  ];

  const handleToggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <>
      <div
        className={`fixed inset-0 bg-black opacity-50 z-40 md:hidden ${
          isOpen ? "block" : "hidden"
        }`}
        onClick={onClose}
      ></div>
      <div
        className={`bg-gray-100 text-black flex flex-col h-screen ${
          isExpanded ? "w-64" : "w-20"
        } fixed top-0 z-50 transition-width duration-300 transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } md:relative md:translate-x-0 overflow-y-auto shadow-lg`}
      >
        <div className="flex items-center justify-between h-16 bg-gray-100 p-4">
          <Link to="/dashboard/home" onClick={onClose}>
            <img
              src={tobreLogo}
              alt="Logo"
              className={`h-8 object-contain transition-opacity duration-300 ${
                isExpanded ? "opacity-100" : "opacity-0"
              }`}
            />
          </Link>
          <button className="text-gray-800" onClick={handleToggleExpand}>
            {isExpanded ? (
              <FaChevronLeft size={20} />
            ) : (
              <FaChevronRight size={20} />
            )}
          </button>
        </div>
        <nav className="flex-grow px-2 py-6">
          <h2
            className={`text-gray-800 text-sm uppercase mb-4 transition-opacity duration-300 ${
              isExpanded ? "opacity-100" : "opacity-0"
            }`}
          >
            Menu
          </h2>
          <ul className="space-y-2">
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  onClick={onClose}
                  className={`flex items-center p-2 space-x-2 squared-md transition-colors duration-200 ${
                    pathname === item.path
                      ? "bg-primary text-white"
                      : "text-gray-800 hover:bg-primary hover:text-white"
                  }`}
                >
                  <item.icon className="text-lg" />
                  {isExpanded && <span>{item.label}</span>}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default SidePanel;
